import { makeStyles } from "@material-ui/core";
import Chip from "@material-ui/core/Chip";
import { InspectionReportStatus } from "../types/types";

const useStyles = makeStyles(() => ({
  notStarted: {
    backgroundColor: "#E0E0E0", // light gray
    color: "#424242",           // dark gray text
  },
  started: {
    backgroundColor: "#BBDEFB", // light blue
    color: "#0D47A1",           // dark blue text
  },
  readyForReview: {
    backgroundColor: "#FFE0B2", // light amber
    color: "#E65100",           // deep orange text
  },
  completed: {
    backgroundColor: "#C8E6C9", // light green
    color: "#1B5E20",           // dark green text
  },
  rejected: {
    backgroundColor: "#FFCDD2", // light red
    color: "#B71C1C",           // deep red text
  },
}));

interface InspectionReportStatusChipProps {
  status: keyof typeof InspectionReportStatus;
}

export const InspectionReportStatusChip = ({ status }: InspectionReportStatusChipProps) => {
  const classes = useStyles();

  let className = null;

  switch (status) {
    case "NOT_STARTED":
      className = classes.notStarted;
      break;
    case "STARTED":
      className = classes.started;
      break;
    case "READY_FOR_REVIEW":
      className = classes.readyForReview;
      break;
    case "COMPLETED":
      className = classes.completed;
      break;
    case "REJECTED":
      className = classes.rejected;
      break;
    default:
      className = classes.notStarted;
  }

  return (<Chip label={InspectionReportStatus[status]} className={className} />);
}